/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { StartProcessRequestDto } from '../models';
/**
 * ProcessesStarterRestApi - axios parameter creator
 */
export const ProcessesStarterRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Start an imported recruitment process with the submitted configuration, claim ownership, transition to IN_PROGRESS and run the description analysis; activation follows asynchronously 
         * @param {string} processId 
         * @param {StartProcessRequestDto} startProcessRequestDto Process configuration for starting an imported process. The configuration form sends these fields without the external linkage, which already exists. The requirements text becomes the process description to analyze. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startProcess: async (processId: string, startProcessRequestDto: StartProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('startProcess', 'processId', processId)
            // verify required parameter 'startProcessRequestDto' is not null or undefined
            assertParamExists('startProcess', 'startProcessRequestDto', startProcessRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/start`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesStarterRestApi - functional programming interface
 */
export const ProcessesStarterRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesStarterRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Start an imported recruitment process with the submitted configuration, claim ownership, transition to IN_PROGRESS and run the description analysis; activation follows asynchronously 
         * @param {string} processId 
         * @param {StartProcessRequestDto} startProcessRequestDto Process configuration for starting an imported process. The configuration form sends these fields without the external linkage, which already exists. The requirements text becomes the process description to analyze. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startProcess(processId: string, startProcessRequestDto: StartProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startProcess(processId, startProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesStarterRestApi.startProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesStarterRestApi - factory interface
 */
export const ProcessesStarterRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesStarterRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Start an imported recruitment process with the submitted configuration, claim ownership, transition to IN_PROGRESS and run the description analysis; activation follows asynchronously 
         * @param {string} processId 
         * @param {StartProcessRequestDto} startProcessRequestDto Process configuration for starting an imported process. The configuration form sends these fields without the external linkage, which already exists. The requirements text becomes the process description to analyze. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startProcess(processId: string, startProcessRequestDto: StartProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.startProcess(processId, startProcessRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessesStarterRestApi - interface
 */
export interface ProcessesStarterRestApiInterface {
    /**
     * 
     * @summary Start an imported recruitment process with the submitted configuration, claim ownership, transition to IN_PROGRESS and run the description analysis; activation follows asynchronously 
     * @param {string} processId 
     * @param {StartProcessRequestDto} startProcessRequestDto Process configuration for starting an imported process. The configuration form sends these fields without the external linkage, which already exists. The requirements text becomes the process description to analyze. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    startProcess(processId: string, startProcessRequestDto: StartProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ProcessesStarterRestApi - object-oriented interface
 */
export class ProcessesStarterRestApi extends BaseAPI implements ProcessesStarterRestApiInterface {
    /**
     * 
     * @summary Start an imported recruitment process with the submitted configuration, claim ownership, transition to IN_PROGRESS and run the description analysis; activation follows asynchronously 
     * @param {string} processId 
     * @param {StartProcessRequestDto} startProcessRequestDto Process configuration for starting an imported process. The configuration form sends these fields without the external linkage, which already exists. The requirements text becomes the process description to analyze. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public startProcess(processId: string, startProcessRequestDto: StartProcessRequestDto, options?: RawAxiosRequestConfig) {
        return ProcessesStarterRestApiFp(this.configuration).startProcess(processId, startProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

